export const filterCollectionByTags = (collection, filterTags) =>
  collection.filter(({ tags }) =>
    filterTags.every((tagName) => tags.some((name) => name === tagName))
  );
